var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('input',{directives:[{name:"theme",rawName:"v-theme",value:(['form.accent', 'form.text']),expression:"['form.accent', 'form.text']"}],ref:"phoneNumber",staticClass:"form-field bg-transparent",attrs:{"type":"tel"},domProps:{"value":_vm.value},on:{"input":function($event){return _vm.$emit('input', $event.target.value)}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }